module.exports = __webpack_public_path__ + "static/media/22.a685eb06.jpg";